module.exports = __webpack_public_path__ + "img/link-learn-desktop_en.22d6fcb.jpg";